var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('img',{attrs:{"src":_vm.logo,"alt":"logo loader"}}),_c('div',{staticClass:"spin"}),_c('div',{staticClass:"text-center"},[_vm._v("Cargando Reporte ...")])])}
var staticRenderFns = []

export { render, staticRenderFns }